//import React from "react";
import "./contactus.css";
import Nav from "../Nav/Nav";
import Footer from "../Footer/Footer";
import emailjs from "@emailjs/browser";
import React, { useRef, useState } from "react";
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

export const gmap = () => {
  window.open("https://maps.app.goo.gl/tt79FD1mh6fyNbnZ8", "_blank");
};

export const callfun = () => {
  window.location.href = "tel:+917002598482";
};
export const mailfun = () => {
  window.location.href = "mailto:galaxcity.gadgets@gmail.com";
};

export function CircularSize() {
  return (
    <Stack spacing={2} direction="row" alignItems="center">
      <CircularProgress size="30px" />
    </Stack>
  );
}
const ContactUs = () => {
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [loading, setLoading] = useState(false);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        "service_xvf5w58",
        "template_k5v14v7",
        form.current,
        "Vbtx6B-aRc2enTVpj"
      )
      .then(
        (result) => {
          console.log(result.text);
           emailjs.send(
            "service_xvf5w58",
            "template_eh8bfym",
            {
              name: form.current.name.value,
              message: "A new subscriber has signed up!",
              subscriber_name: form.current.name.value,
              subscriber_email: form.current.email.value,
              time: new Date().toLocaleString(),
              email: form.current.email.value,
            },
            "Vbtx6B-aRc2enTVpj"
          );

          e.target.reset();
          setLoading(false);
          setShowMessage(true);
          setMessage("Message sent successfully!");          
          setTimeout(() => {
            setShowMessage(false);
          }, 3000);

        },
        (error) => {
          console.error(error);
          setLoading(false);
          setMessage("Failed to send message. Try again later!");
          setShowMessage(false);
        }
      );
  };
  return (
    <div className="contact-us">
      <Nav theme="light" />
      <div className="super-container">
        <div className="container">
          <div className="info">
            <h1>Contact Us</h1>
            <p>
              Have questions, feedback, or need support? We’re always here to
              help you.
              <br />
              Whether you're facing a technical issue, want to know more about
              our services, or simply have something to share —
            </p>

            <div className="info-box">
              <img
                src="https://cdn-icons-png.flaticon.com/512/484/484167.png"
                alt="address"
              />
              <div onClick={() => gmap()} style={{ cursor: "pointer" }}>
                <strong>Address</strong>
                <br />
                Galaxcity Gadgets Thangal Bazar, <br />
                Imphal Manipur, Pin-795001
              </div>
            </div>

            <div className="info-box">
              <img
                src="https://cdn-icons-png.flaticon.com/512/724/724664.png"
                alt="phone"
              />
              <div onClick={() => callfun()} style={{ cursor: "pointer" }}>
                <strong>Phone</strong>
                <br />
                7005665616
              </div>
            </div>

            <div className="info-box">
              <img
                src="https://cdn-icons-png.flaticon.com/512/732/732200.png"
                alt="email"
              />
              <div onClick={() => mailfun()} style={{ cursor: "pointer" }}>
                <strong>Email</strong>
                <br />
                galaxcity.gadgets@gmail.com
              </div>
            </div>
          </div>

          <div className="form-box">
            <h2>Send Message</h2>
            {loading &&(<div className="d-flex align-items-center gap-2"><p className="w-100 message alert alert-primary d-flex justify-content-between align-items-center gap-2">Sending your message... <CircularSize /></p> </div>)}
            {showMessage && <p className={`${message.includes('successfully') ? 'alert alert-success' : "alert alert-warning"} message`}>{message}</p>}

            <form ref={form} onSubmit={sendEmail}>
              <input type="text" name="name" placeholder="Your Name" required />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                required
              />

              <input
                type="text"
                name="title"
                placeholder="Subject Title"
                required
              />

              <input
                type="text"
                name="time"
                value={new Date().toLocaleString()}
                readOnly
                hidden
              />

              <textarea name="message" placeholder="Your Message" required />

              <button type="submit">Send Message</button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
//Test

export default ContactUs;
